import { render, staticRenderFns } from "./PillsPdfPage.vue?vue&type=template&id=7e7ec26b&"
import script from "./PillsPdfPage.vue?vue&type=script&lang=js&"
export * from "./PillsPdfPage.vue?vue&type=script&lang=js&"
import style0 from "./PillsPdfPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports